import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { generatePath, useParams, useRouteMatch } from 'react-router-dom';

import messages from 'messages';
import {
  ActionButton,
  Panel,
  PanelBody,
  PanelSubtitle,
  PanelTitle,
  PanelTitleButtonsGroup,
  PanelTitleWrapper,
  RefactoredPanelHeader
} from 'components/panel';

import {
  ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTIONS,
  ROUTE_EXERCISES_COLLECTIONS_ENTITY_MY_COLLECTIONS,
  ROUTE_EXERCISES_COLLECTIONS_ENTITY_OTHER_COLLECTIONS
} from 'routes/RouteList';
import BreadcrumbPath from 'containers/partials/misc/BreadcrumbPath';
import { useAbility } from '@casl/react';
import { AbilityContext } from 'Can';
import { TabList, TabPanel, Tabs } from 'components/tabs';
import AddCollectionModal from 'containers/pages/exercises/collections/AddCollectionModal';
import TabPanelBody from 'components/tabs/TabPanelBody';
import AddButton from 'containers/partials/buttons/AddButton';
import TabLink from 'components/tabs/TabLink';
import CollectionsTab from 'containers/pages/exercises/collections/CollectionsTab';
import OtherCollectionsTab from 'containers/pages/exercises/collections/OtherCollectionsTab';

const Collections = () => {
  const { entityId } = useParams();
  const ability = useAbility(AbilityContext);
  const active = useRouteMatch(ROUTE_EXERCISES_COLLECTIONS_ENTITY_COLLECTIONS);
  const [addModalData, setAddModalData] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);

  return (
    <Panel active={active.isExact}>
      <RefactoredPanelHeader>
        <PanelTitleWrapper>
          <BreadcrumbPath crumbs={[]} />
          <PanelTitle>
            <FormattedMessage {...messages.collectionsTitle} />
          </PanelTitle>
          <PanelSubtitle>
            {tabIndex === 1 ? (
              <FormattedMessage {...messages.collectionsSubtitleOther} />
            ) : (
              <FormattedMessage {...messages.collectionsSubtitleMine} />
            )}
          </PanelSubtitle>
        </PanelTitleWrapper>
        <PanelTitleButtonsGroup>
          {ability.can('create', 'Template') && (
            <ActionButton>
              <AddButton
                expandable
                label={
                  <FormattedMessage
                    {...messages.exercisesAddCollectionButton}
                  />
                }
                onClick={() => setAddModalData(true)}
              />
            </ActionButton>
          )}
        </PanelTitleButtonsGroup>
      </RefactoredPanelHeader>
      <PanelBody>
        <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
          <TabList>
            <TabLink
              to={generatePath(
                ROUTE_EXERCISES_COLLECTIONS_ENTITY_MY_COLLECTIONS,
                { entityId }
              )}
              key={`collections.my`}
            >
              <FormattedMessage {...messages.collectionsTabMyCollections} />
            </TabLink>
            <TabLink
              to={generatePath(
                ROUTE_EXERCISES_COLLECTIONS_ENTITY_OTHER_COLLECTIONS,
                { entityId }
              )}
              key={`collections.other`}
            >
              <FormattedMessage {...messages.collectionsTabAllCollections} />
            </TabLink>
          </TabList>
          <TabPanel>
            <TabPanelBody withScroller withHeader>
              <CollectionsTab />
            </TabPanelBody>
          </TabPanel>
          <TabPanel>
            <TabPanelBody withHeader>
              <OtherCollectionsTab />
            </TabPanelBody>
          </TabPanel>
        </Tabs>
      </PanelBody>

      {addModalData && (
        <AddCollectionModal
          entityId={entityId}
          onClose={() => setAddModalData(false)}
        />
      )}
    </Panel>
  );
};

export default Collections;
